import { useState } from 'react';
import clsx from 'clsx';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/16/solid';

interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  /** Abierto por defecto (como en el sidebar). */
  defaultOpen?: boolean;
}

export default function CollapsibleSection({
  title,
  children,
  className,
  defaultOpen = true,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section
      className={clsx(
        'flex flex-col flex-shrink-0 border-b border-gray-100 min-w-0 last:border-b-0',
        className,
      )}
    >
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="flex items-center gap-2 w-full min-w-0 px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider bg-gray-50/80 hover:bg-gray-100 flex-shrink-0 text-left"
        aria-expanded={open}
      >
        {open ? (
          <ChevronDownIcon className="w-4 h-4 flex-shrink-0" />
        ) : (
          <ChevronRightIcon className="w-4 h-4 flex-shrink-0" />
        )}
        <span className="truncate">{title}</span>
      </button>
      {open && <div className="px-2 pb-2 min-w-0">{children}</div>}
    </section>
  );
}
